import { Button, ConfigProvider, Flex, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import { green } from '@ant-design/colors'

type Props = {
  open: boolean
  onClose: () => void
}

const INVOICING_SETTINGS_URL = '/#!/invoicing-settings'

const BatchInvoicingUpgradeModal = ({ open, onClose }: Props) => {
  const handleManageInvoicingSettings = () => {
    window.location.href = INVOICING_SETTINGS_URL
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={null}
      width={900}
      styles={{ body: { padding: 0 }, content: { padding: 0, overflow: 'hidden' } }}
    >
      <Flex>
        <div style={{ flex: '0 0 calc(50% - 32px)', padding: '52px 32px 24px 32px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1, paddingBottom: 20 }}>
            <div style={{ fontSize: 32, fontWeight: 700, lineHeight: 1.2, marginBottom: 24 }}>
              Unlock Batch Invoicing With SynkedUP Payments
            </div>

            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
                <FontAwesomeIcon icon={faCircleCheck} color={green.primary} style={{ marginTop: 4, fontSize: 18, flexShrink: 0 }} />
                <span>
                  <strong>Batch create invoices</strong> &mdash; Create invoices for multiple jobs at once instead of one at a time. Less clicking, more earning.
                </span>
              </li>
              <li style={{ display: 'flex', gap: 12 }}>
                <FontAwesomeIcon icon={faCircleCheck} color={green.primary} style={{ marginTop: 4, fontSize: 18, flexShrink: 0 }} />
                <span>
                  <strong>Batch send invoices</strong> &mdash; send invoices to your customers all at once and start collecting payments faster.
                </span>
              </li>
            </ul>

            <Flex gap={8} justify="flex-start" style={{ marginTop: 'auto', paddingTop: 24 }}>
              <Button onClick={onClose}>Close</Button>
              <ConfigProvider theme={{ token: { colorPrimary: '#ff5c35' } }}>
                <Button type="primary" onClick={handleManageInvoicingSettings}>
                  Manage Invoicing Settings
                </Button>
              </ConfigProvider>
            </Flex>
          </div>
        </div>

        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          overflow: 'hidden',
          borderBottomRightRadius: 8,
        }}>
          <img
            src="/images/batch-invoicing-upgrade/macbook-batch-history.png"
            alt="Batch history screen on a MacBook"
            style={{ display: 'block', width: '100%', height: 'auto' }}
          />
        </div>
      </Flex>
    </Modal>
  )
}

export default BatchInvoicingUpgradeModal
